import React from 'react'
import { connect } from 'react-redux';

let lines = {}

let lineIDs = {}

let reducers = {}

function reducerFactory(id, name, initState) {
  return (state = initState, action)=>{
    if (action.type.indexOf(id) > -1) {
      return {
        ...state,
        ...action.payload,
      }  
    } 

    return state;
  }
}

export function getReducers(store) {
  return reducers;
}

export const install = (name, initState = {}, methods)=> {
  lines[name] = methods;

  let id = name + '_' + Math.random().toString(36).substring(7); 
  
  lineIDs[name] = id;

  reducers[name] = reducerFactory(id, name, initState);
}

// Simple wrapper again wrapped by connect
// DO NOT rewrap it with connect. This can be used as an alternative
// to Redux connect.
export const hotline = function(Target, ...names) {

  class Hotline extends React.Component {
    
      constructor(props) {
        super(props);
        
        this._setStateByDispatch = this._setStateByDispatch.bind(this);
        
        this._updateMethodParams = this._updateMethodParams.bind(this);

        this.processed = {}

        this.methodParams = {}

        this.state = {}
        
        names.map((storeName)=>{
          let name = storeName;
      
          this.processed[name] = {};
          
          let methods = lines[name] || {};
          let state = this.props.__hotlines[name]
          
          this.methodParams[name] = {};
          
          Object.keys(methods).map((methodName)=>{
            this.methodParams[name][methodName] = {
              state,
              methods: this.processed,
            }
            
            const processedMethod = (context, ...args) => {
              this.methodParams[name][methodName].setState = this._setStateByDispatch(name, methodName, context), 

              methods[methodName](this.methodParams[name][methodName], ...args);
            };

            this.processed[name][methodName] = processedMethod;
          
          });

        });

      }
    
      componentWillReceiveProps(nextProps) {
        this._updateMethodParams(nextProps); 
      }

      //
      // update this.methodParams through reference
      //
      _updateMethodParams(nextProps) {
        names.map((name)=>{
          let methods = lines[name] || {};
          
          Object.keys(methods).map((methodName)=>{
           
            this.methodParams[name][methodName].state = nextProps.__hotlines[name]

            const processedMethod = (context, ...args) => {
              this.methodParams[name][methodName].setState = this._setStateByDispatch(name, methodName, context), 
              methods[methodName](this.methodParams[name][methodName], ...args);
            };

            this.processed[name][methodName] = processedMethod;
          
          });
        });

      }

      _setStateByDispatch(name, key, context) {
        let fn = name + '.' + key;
        
        return (payload, cb)=>{

          if (typeof context !== 'string') {
            throw new Error(`${fn}() is missing a context (string). Pass a string as a context as its first param. Eg. ${fn}('when login button is clicked')`);
          }

          const type = `${fn}() ${context}`.toUpperCase() + ` [${lineIDs[name]}]`;

          //
          // wrapped by redux connect. We will use their dispatch
          //
          this.props.dispatch({
            type,
            payload,
          })

          this._updateMethodParams(this.props);

          if (typeof cb === 'function') {
            cb();
          }

          // this.forceUpdate()

        }
      }

      render() {
        let processed = {}
        if (this.processed) {
          //
          // messy but no choice
          //
          names.map((name)=>{

            if (this.props[name]) {
              console.warn(`${name}`);
            }

            processed[name] = {
              ...this.processed[name],
              ...this.props.__hotlines[name],
              }
            });
        }

        //
        // The order of passing props is not very explcit
        // but DO NOT change the order
        //
        return (
          <Target
            {...this.props}
            {...processed}
          />
        );
      }
    }

  return connect((reduxStates)=>{
    let __hotlines = {}
    names.forEach((name)=>{
      __hotlines[name] = reduxStates[name]
    });

    return {
      __hotlines
    }
  })(Hotline);
}





// WEBPACK FOOTER //
// ./src/vendor/react-redux-hotline/index.js